import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import AOS from "aos";
import Navbar from "../../Components/navbar/Navbar";
import Hero from "../../Components/hero/Hero";
import Features from "../../Components/features/Features";
import Aboutus from "../../Components/aboutus/Aboutus";
import Footer from "../../Components/footer/Footer";
import { Link } from "react-router-dom";
import { features } from "./data";

const Landing = () => {
  const location = useLocation();

  useEffect(() => {
    try {
      AOS.init();
    } catch (error) {
      // Non-critical animation init
    }

    if (location.state?.scrollTo) {
      const { scrollTo } = location.state;
      document.getElementById(scrollTo)?.scrollIntoView({ behavior: "smooth" });
    }
  }, [location]);

  // JSON-LD schema for the organization
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "TINT",
    "logo": "/images/tint-logo.png",
    "description": "TINT connects tech professionals, organizations, and resources. Join our community to access projects, jobs, and learning resources in the technology sector.",
    "sameAs": [
      "https://twitter.com/tint",
      "https://www.linkedin.com/company/tint",
      "https://www.facebook.com/tint"
    ]
  };

  return (
    <>
      <Helmet>
        {/* Additional Meta Tags */}
        <meta name="keywords" content="technology, innovation, network, training, tech jobs, tech projects, learning resources" />
        <meta name="author" content="TINT" />

        {/* JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      </Helmet>

      <header className="header-2 primary" id="top">
        <Navbar
          navClass="navbar-light zindex-10"
          isSticky={false}
          fixedWidth
          hideSearch
          buttonClass="btn-primary btn-sm"
        />
        <div>
          <Hero />
        </div>
      </header>
      
      <main>
        <section id="aboutus">
          <Aboutus />
        </section>
        
        <section id="features">
          <Features
            features={features}
            containerClass="position-relative overflow-hidden pt-lg-6 py-4 pb-lg-7"
          />
        </section>
      </main>

      <Footer />
      
      {/* Visible footer navigation for crawlers and accessibility */}
      <nav className="visually-hidden" aria-label="TINT platform pages">
        <ul>
          <li><Link to="/categories">Resources</Link></li>
          <li><Link to="/privacy-policy">Privacy Policy</Link></li>
          <li><Link to="/terms-and-conditions">Terms and Conditions</Link></li>
          <li><Link to="/contact">Contact Us</Link></li>
          <li><Link to="/signup">Sign Up</Link></li>
          <li><Link to="/signin">Sign In</Link></li>
        </ul>
      </nav>
    </>
  );
};

export default Landing;
